import { css } from '@/styled-system/css';

export const newUnitBadgeWrapperStyles = css({
  display: 'inline-block',
  // Override TooltipV2's focus styles
  '& [data-testid="new-unit-badge-tooltip"]:focus': {
    outlineWidth: '0 !important',
    outlineStyle: 'none !important',
    outlineOffset: 'initial',
  },
});

export const getNewUnitBadgeStyles = (variant: 'hdp' | 'srp' = 'hdp') => {
  if (variant === 'srp') {
    // SRP variant: matches getInfoBadgeCX styling from ListingCardV3
    return css({
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#189C88', // Same as HDP variant
      color: '#FFFFFF',
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: '600',
      paddingTop: '2px',
      paddingRight: '8px',
      paddingBottom: '1px',
      paddingLeft: '8px',
      borderRadius: '48px', // Pill shape
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      // Custom focus ring for better accessibility
      '&:focus': {
        outlineWidth: '2px !important',
        outlineStyle: 'solid !important',
        outlineColor: '#0066CC !important',
        outlineOffset: '2px !important',
      },
      _focus: {
        outlineWidth: '2px !important',
        outlineStyle: 'solid !important',
        outlineColor: '#0066CC !important',
        outlineOffset: '2px !important',
      },
    });
  }

  // HDP variant: original styling with fixed width
  return css({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#189C88',
    color: '#FFFFFF',
    fontSize: '10px',
    lineHeight: '16px', // Match badge height for proper centering
    fontWeight: 'bold',
    textDecoration: 'underline',
    textDecorationThickness: '5%',
    width: '60px', // Mobile width
    height: '16px',
    borderRadius: '12px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    md: {
      width: '68px', // Desktop width - less cramped appearance
    },
    // Custom focus ring for better accessibility
    '&:focus': {
      outlineWidth: '2px !important',
      outlineStyle: 'solid !important',
      outlineColor: '#0066CC !important',
      outlineOffset: '2px !important',
    },
    _focus: {
      outlineWidth: '2px !important',
      outlineStyle: 'solid !important',
      outlineColor: '#0066CC !important',
      outlineOffset: '2px !important',
    },
  });
};

// Legacy export for backwards compatibility
export const newUnitBadgeStyles = getNewUnitBadgeStyles('hdp');
